import React from "react";
import NumberFormat from 'react-number-format';

export function numberWithCommaEmptyValue(value, align, allowNegative, decimalScale, fixedDecimalScale) {
    if ((value * 1 < 0) && (!allowNegative)) {
        return '';
    }

    let numberValue = Number(value) === 0 ? '' : Number(value);

    return <NumberFormat
        value={numberValue}
        displayType={'text'}
        decimalScale={decimalScale ? decimalScale : 0}
        fixedDecimalScale={fixedDecimalScale ? fixedDecimalScale : false}
        thousandSeparator={true}
        renderText={
            value =>
                <div style={{textAlign: align === undefined ? "left" : align}}>{value}</div>
        }/>;
}


export function numberWithComma(value, align, allowNegative, decimalScale, fixedDecimalScale) {
    if ((value * 1 < 0) && (!allowNegative)) {
        return '';
    }
    return <NumberFormat
        value={Number(value)}
        displayType={'text'}
        decimalScale={decimalScale ? decimalScale : 0}
        fixedDecimalScale={fixedDecimalScale ? fixedDecimalScale : false}
        thousandSeparator={true}
        renderText={
            value =>
                <div style={{textAlign: align === undefined ? "left" : align}}>{value}</div>
        }/>;
}

export function numberWithCommaEmptyValueDataTableTemplate(rowData, column) {
    return numberWithCommaEmptyValue(rowData[column['field']], "right");
}

export function numberWithCommaDataTableTemplate(rowData, column) {
    return numberWithComma(rowData[column['field']], "right");
}

export function numberWithCommaText(value) {
    if (value !== undefined) {
        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    } else {
        return '';
    }
}

export function numberWithoutComma(value, align) {
    if (value * 1 < 0) {
        return '';
    }
    return <NumberFormat
        value={value}
        displayType={'text'}
        decimalScale={0}
        renderText={
            value =>
                <div style={{textAlign: align === undefined ? "left" : align}}>{value}</div>
        }/>;
}

export function numberWithoutCommaDataTableTemplate(rowData, column) {
    return numberWithoutComma(rowData[column['field']], "right");
}

export function percent(value, align, decimals) {
    return <NumberFormat
        value={value < 0 ? "" : value}
        displayType={'text'}
        suffix={"%"}
        thousandSeparator={true}
        decimalScale={decimals === undefined ? 2 : decimals}
        fixedDecimalScale={true}
        renderText={
            value =>
                <div style={{textAlign: align === undefined ? "left" : align}}>{value}</div>
        }/>;
}

export function percentDataTableTemplate(rowData, column, decimals) {
    return percent(rowData[column['field']], "right", decimals);
}
export function percentFourDecimalsDataTableTemplate(rowData, column) {
    return percent(rowData[column['field']], "right", 4);
}

export function multipliedOneHundred(value, align, decimals, suffix){
    let multiplied = value * 100;

    return <NumberFormat
        value={multiplied}
        displayType={'text'}
        thousandSeparator={true}
        decimalScale={decimals}
        fixedDecimalScale={true}
        suffix={(!(suffix === undefined || suffix === false)) ? "%" : ""}
        renderText={
            multiplied =>
                <div style={{textAlign: align === undefined ? "left" : align}}>{multiplied}</div>
        }/>;
}

export function capacityMultipliedOneHundred(value, align, suffix) {
    return multipliedOneHundred(value, align, 4, suffix)
}

export function capacityMultipliedOneHundredTemplate(rowData, column) {
    return multipliedOneHundred(rowData[column['field']], "right", 4);
}

export function requiredPercentMultipliedOneHundred(value, align) {
    return multipliedOneHundred(value, align, 4)
}

export function rateMultipliedByOneHundred(value, align) {
    if (value * 1 < 0) {
        return '';
    }
    return rate(value * 100, align);
}


export function rate(value, align, withNegative) {
    if (withNegative === undefined && value * 1 < 0) {
        return '';
    }
    return <NumberFormat
        value={value}
        displayType={'text'}
        thousandSeparator={true}
        decimalScale={2}
        fixedDecimalScale={true}
        renderText={
            value =>
                <div style={{textAlign: align === undefined ? "left" : align}}>{value}</div>
        }/>;
}

export function rateDataTableTemplate(rowData, column) {
    return rate(rowData[column['field']], "right");
}

export function rateWithNegativesMultipliedByOneHundredDataTableTemplate(rowData, column) {
    let rateValue = rowData[column['field']] * 100;
    return rate(rateValue, "right", true);
}

export function rateMultipliedByOneHundredDataTableTemplate(rowData, column) {
    let rateValue = rowData[column['field']] * 100;
    return rate(rateValue, "right");
}

export function amountCalculate(value) {
    return value.toFixed(2);
}

export function rateCalculate(value) {
    return value.toFixed(2);
}

export function amount(value, align, withNegative) {
    if (withNegative === undefined && value * 1 < 0) {
        return '';
    }

    return <NumberFormat
        value={value}
        displayType={'text'}
        prefix={"$"}
        thousandSeparator={true}
        decimalScale={2}
        fixedDecimalScale={true}
        renderText={
            value =>
                <div style={{textAlign: align === undefined ? "left" : align}}>{value}</div>
        }/>;
}

export function amountWithNegativesDataTableTemplate(rowData, column) {
    return amount(rowData[column['field']], "right", true);
}

export function amountDataTableTemplate(rowData, column) {
    return amount(rowData[column['field']], "right");
}

export function price(value, align, prefix) {
    if (value * 1 < 0) {
        return '';
    }
    return <NumberFormat
        value={value}
        displayType={'text'}
        prefix={prefix ? prefix : "$"}
        thousandSeparator={true}
        decimalScale={6}
        fixedDecimalScale={true}
        renderText={
            value =>
                <div style={{textAlign: align === undefined ? "left" : align}}>{value}</div>
        }/>;
}

export function priceDataTableTemplate(rowData, column) {
    return price(rowData[column['field']], "right");
}

export function priceNonPrefixDataTableTemplate(rowData, column) {
    return price(rowData[column['field']], "right", " ");
}


/**
 * Función que valida un número para que contenga el número de enteros y decimales
 * especificados. En caso de contener más enteros, corta el número hasta donde se
 * indica y lo regresa.
 * @param {Number} number Número a validar.
 * @param {Number} nIntegers Número de digitos enteros deseado.
 * @param {Number} nDecimals Número de digitos décimales deseado.
 * @returns {number|*} Número validado.
 */
export function validateNumberIntegersDecimals(number, nIntegers, nDecimals) {
    let numberStr = number.toString();
    let regex = new RegExp("/^\\d{0," + nIntegers + "}(\\.\\d{1," + nDecimals + "})?$/")
    if (regex.exec(numberStr)) {
        return number;
    } else {
        let arrayNumber = numberStr.split(".");
        let integerStr = arrayNumber[0] ? arrayNumber[0] : 0;
        let decimalStr = arrayNumber[1] ? arrayNumber[1] : 0;
        let newInteger = integerStr.substring(0, nIntegers);
        return Number(newInteger + "." + decimalStr)
    }
}

export function capacity(value, align) {
    value = value !== undefined ? value * 100 : '';
    return <NumberFormat
        value={value}
        displayType={'text'}
        suffix={"%"}
        thousandSeparator={true}
        decimalScale={4}
        fixedDecimalScale={true}
        renderText={
            value =>
                <div style={{textAlign: align === undefined ? "left" : align}}>{value}</div>
        }/>;
}

export function decimalFormat(value, align, decimals, suffix) {
    return <NumberFormat
        value={value}
        displayType={'text'}
        thousandSeparator={true}
        decimalScale={decimals}
        fixedDecimalScale={true}
        suffix={(!(suffix === undefined || suffix === false)) ? "%" : ""}
        renderText={
            value =>
                <div style={{textAlign: align === undefined ? "left" : align}}>{value}</div>
        }/>;
}

export function replaceStringIfZero(value) {
    let replaceString = '-';
    return Number(value) === 0 ? replaceString : value
}

export function percentageDataTableTemplate(rowData, column) {
    return decimalFormat(rowData[column['field']], "right", 4);
}

export function formattedPremium (value, align) {
    let replaceString = <div>-</div>;
    return Number(value) === 0 ? replaceString : amount(value, align)
}
export function formattedNumber (value, align) {
    let replaceString = <div>-</div>;
    return Number(value) === 0 ? replaceString : numberWithComma(value, align)
}

export function bilateralAmountDataTableTemplate(rowData, column) {
    return amount(rowData[column['field']], "right");
}